import React from "react";
import { LoadingBar } from "./styles";

const Screen = ({ color, progress, height }) => {
  return <LoadingBar height={height} color={color} progress={progress} />;
};

export default Screen;
